import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['modal'];

  openModal(event) {
    event.preventDefault();
    $('#proposal-panel-modal').modal('show');
  }
}